module.exports = __webpack_public_path__ + "img/add_cart.6680232f.svg";